import 'css-chunk:src/app/components/ApplicationPageTemplates/QuickTemplate/Intro/SocialLinks.scss';export default {
  "SocialLinks": "_SocialLinks_wc9o5_1"
};